import { Teeth } from '../../../Assets/SVGS';
import { useTranslation } from 'react-i18next';
import PlansCard from '../../../Component/HomeComponents/PlansSection/PlansCard/PlansCard';
import LandPage from '../../../Component/common/LandPage/LandPage'
import Navbar from '../../../Component/common/Navbar/Navbar'
import Topbar from '../../../Component/common/Topbar/Topbar'
import Footer from '../../../Component/common/Footer/Footer';
function Booking(){
  const { t } = useTranslation();
  return (
    <div className='services-container'>
      <Topbar />
      <Navbar />
      <LandPage
        header={t('bookAppointment')}
        link={t('bookAppointment')}
        href='/book-appointment'
      />
      <div className='plansSection-container container'>
        <div className='plansSection-content content'>
          <PlansCard
            icon={<Teeth width='50px' />}
            header={t('normalBooking')}
            price='100'
            list={[
              t('normalBookingList1'),
              t('normalBookingList2'),
              t('normalBookingList3'),
              t('normalBookingList4'),
              t('normalBookingList5'),
            ]}
            link="booking"
          />
          <PlansCard
            icon={<Teeth width='50px' />}
            header={t('fastBooking')}
            price='150'
            list={[
              t('fastBookingList1'),
              t('fastBookingList2'),
              t('fastBookingList3'),
              t('fastBookingList4'),
              t('fastBookingList5'),
            ]}
            link="fast-booking"
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Booking